// extracted by mini-css-extract-plugin
export default {"wrapper":"landscapeOverlay__wrapper__htXJ3","phoneIcon":"landscapeOverlay__phoneIcon__fq293","phoneRotate":"landscapeOverlay__phoneRotate__FCulW"};